import _ from 'lodash';

export const memoize = fn => _.memoize(fn, (...args) => JSON.stringify(args));
